import * as React from 'react';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import { useMutation } from '@grandvisionhq/graphql';
import { isNil } from '@grandvisionhq/utils';
import '../operations/fragments/cart-details.js';
import '../operations/fragments/cart-validation-errors.js';
import '../operations/fragments/recover-inactive-cart-failure.js';
import '../operations/fragments/recover-inactive-cart-result.js';
import '../operations/mutations/add-cart-line-items.js';
import '../operations/mutations/add-cart-voucher-codes.js';
import '../operations/mutations/create-cart.js';
import '../operations/mutations/remove-cart-voucher-codes.js';
import '../operations/mutations/remove-cart-line-items.js';
import '../operations/mutations/update-cart-line-items.js';
import '../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import { RECOVER_INACTIVE_CART } from '../operations/mutations/recover-inactive-cart.js';
import '../operations/queries/get-cart.js';
import '../operations/queries/get-total-line-items.js';
import '../operations/queries/get-cart-estimated-delivery.js';
import '@swc/helpers';
import '../utils/cart-count-var.js';
import { cartIdVar } from '../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../utils/get-unrecoverable-validation-errors.js';
import '../models/add-to-cart/add-to-cart.js';
import '../models/subscription/subscription-details.js';
import '../models/checkoutState/checkoutState.js';
import '../models/line-item/prescription-glasses.js';
import '../utils/get-failure-error-codes.js';

const useRecoverInactiveCart = ({ reset , onComplete  })=>{
    const { href: homeHref  } = useLink({
        route: 'home'
    }, {
        replace: true
    }) || {};
    const { replace  } = useLocation();
    const [recoverInactiveCart, recoverCartMutation] = useMutation(RECOVER_INACTIVE_CART, {
        onCompleted: (response)=>{
            var ref;
            const newCartData = response === null || response === void 0 ? void 0 : response.recreateOrderedCheckout;
            if (newCartData.newCheckoutId && newCartData.checkoutHash) {
                onComplete(newCartData.newCheckoutId, newCartData.checkoutHash);
            }
            if (!newCartData.success && ((ref = newCartData.failures) === null || ref === void 0 ? void 0 : ref.length)) {
                newCartData.failures.forEach((errorItem)=>console.error(`Failed to recover cart with code ${errorItem.code}`)
                );
                reset();
                homeHref && replace(homeHref);
            }
        },
        onError: (error)=>{
            reset();
            homeHref && replace(homeHref);
            console.error(`cart recovery failed:${error.message}`);
        },
        fetchPolicy: 'no-cache'
    });
    const { called , loading , error: error1  } = recoverCartMutation;
    const recoverCart = React.useCallback((cartId)=>{
        if (isNil(cartId) && cartId !== cartIdVar()) {
            console.error('No cart ID available');
            return;
        }
        recoverInactiveCart({
            variables: {
                cartParams: {
                    checkoutId: cartId
                }
            }
        });
    }, [
        recoverInactiveCart
    ]);
    return [
        recoverCart,
        {
            called,
            loading,
            error: error1
        }
    ];
};

export { useRecoverInactiveCart };
//# sourceMappingURL=use-recover-inactive-cart.js.map
